import React, { useEffect, useMemo, useState } from 'react'
import style from '../../styles/Cabinet/HomePage.module.css';
import useLogout from 'src/hooks/useLogout';
import { Box, Button, Card, CardContent, CircularProgress, Grid, Switch, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/interface/IRootState';


interface HomePageProps {
  loading: boolean;
}

const HomePage: React.FC<HomePageProps> = ({ loading }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showZeroBalances, setShowZeroBalances] = useState(false);
  const [displayedBalances, setDisplayedBalances] = useState<[string, number][]>([]);
  const [logoutUser] = useLogout();

  const userData = useSelector((state: RootState) => state.userData);
  const userBalance = useSelector((state: RootState) => state.balance);

  // const memoizedUserData = useMemo(() => userData, [userData]);
  // const memoizedUserBalance = useMemo(() => userBalance, [userBalance]);

  useEffect(() => {
    function checkStatus() {
      const balances = showZeroBalances
        ? Object.entries(userBalance.balance).filter(([_, value]) => value > 0)
        : Object.entries(userBalance.balance)

      setDisplayedBalances(balances);
    }

    checkStatus();
  }, [showZeroBalances, userBalance]);


  const handleLogout = () => {
    setShowModal(true)
  }

  const confirmLogout = () => {
    logoutUser();
    setShowModal(false);
  }

  const cancelLogout = () => {
    setShowModal(false);
  };


  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    )
  }

  return (
    <div className={style.container}>
      {showModal && (
        <div className={style.modal}>
          <div className={style.modalContent}>
            <h3>Вы действительно хотите выйти?</h3>
            <div className={style.modalButtons}>
              <button onClick={confirmLogout}>Yes</button>
              <button onClick={cancelLogout}>No</button>
            </div>
          </div>
        </div>
      )}

      <Grid container justifyContent="center" style={{ padding: '20px' }} spacing={3} direction={'column'}>
        <Grid item xs={12} sm={8} md={6}>
          <Card style={{ width: '100%', borderRadius: '10px' }}>
            <CardContent>
              <Typography variant="h4" gutterBottom>
                User Information
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Email:</strong> {userData.email}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Telegram ID:</strong> {userData.telegramId}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: '20px', width: '100%' }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={8} md={6}>
          <Card style={{ width: '100%', borderRadius: '10px' }}>
            <CardContent>
              <Typography variant="h4" gutterBottom>
                Балансы монет
              </Typography>

              <div style={{ marginBottom: '20px' }}>
                <Typography variant="body1">
                  Скрыть нулевые активы
                </Typography>
                <Switch
                  checked={showZeroBalances}
                  onChange={() => setShowZeroBalances(!showZeroBalances)}
                  name="showZeroBalances"
                  color="primary"
                />
              </div>

              <div className={style.balanceContainer}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>Монета</strong></TableCell>
                      <TableCell><strong>Баланс</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayedBalances.length > 0
                      ? (displayedBalances.map(([coinName, coinBalance]) => (
                        <TableRow key={coinName}>
                          <TableCell>{coinName.toUpperCase()}</TableCell>
                          <TableCell>{coinBalance.toFixed(4)}</TableCell>
                        </TableRow>
                      )))
                      : (
                        <p>No balances</p>
                      )}
                  </TableBody>
                </Table>
              </div>

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}

export default HomePage